import Doars from './Doars.js'
import { interpret } from './utilities/Interpret.js'

Doars.interpretExpression = interpret

export default Doars
